// src/components/Icon.tsx
import React from "react";
import icons from "./helper";

type IconName =
  | "Undo"
  | "Redo"
  | "Bold"
  | "Italic"
  | "Underline"
  | "Color"
  | "LeftAlign"
  | "RightAlign"
  | "CenterAlign"
  | "UnOrderedList"
  | "OrderedList"
  | "IndentLess"
  | "IndentMore"
  | "RemoveFormat"
  | "StrikeThrough"
  | "CodeQuote"
  | "DownArrow"
  | "Styling"
  | "Attach"
  | "Link"
  | "Image"
  | "Check"
  | "TextFields"
  | "Edit"
  | "Close"
  | "Emoji"
  | "LockClock"
  | "GoogleDrive"
  | "Signature"
  | "InsertImage"
  | "Ban"
  | "Pdf"
  | "Doc"
  | "Zip"
  | "Exe"
  | "Bmp"
  | "Png"
  | "Jpg"
  | "Xls"
  | "Xlsx"
  | "Csv"
  | "File";

interface IconProps {
  name: IconName;
  size?: number;
  color?: string;
  className?: string;
}

const Icon: React.FC<IconProps> = ({ name, size = 24, color, className }) => {
  // ✅ Map each icon to a name

  const IconComponent = icons[name];

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found.`);
    return null;
  }

  return <IconComponent size={size} color={color} className={className} />;
};

export default Icon;
